import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ImportantItemFilter]',
    standalone: false
})
export class ImportantItemFilterDirective {}
